
import Vue from "vue";
import {CustomButton} from "@/utils/buttons/custom-button";
import AppIconPicker from "@/components/view-editor/IconPicker.vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => CustomButton,
			required: true
		},
	},
	computed: {
		positionItems(){
			return [
				{text: this.$ct("custom-buttons.labels.position-start"), value: "start"},
				{text: this.$ct("custom-buttons.labels.position-end"), value: "end"}
			];
		},
		iframePositionItems(){
			return [
				{text: this.$ct("custom-buttons.labels.iframe-position-left"), value: "left"},
				{text: this.$ct("custom-buttons.labels.iframe-position-right"), value: "right"}
			];
		},
		iframeWidthModeItems(){
			return [
				{text: this.$ct("custom-buttons.labels.iframe-width-mode-fixed"), value: 0},
				{text: this.$ct("custom-buttons.labels.iframe-width-mode-percent"), value: 1},
				{text: this.$ct("custom-buttons.labels.iframe-width-mode-variable"), value: 2}
			];
		}
	},
	methods: {
		onRequireSingleChanged(checked: boolean){
			if (checked) this.value.RequireSelection = false;
		},
		onRequireSelectionChanged(checked: boolean){
			if (checked) this.value.RequireSingle = false;
		},
		close(){
			this.$emit("close");
		},
		save(){
			this.$emit("save");
		}
	},
	components: {
		AppIconPicker
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
